import React from 'react'
import { MultiSelect } from 'components'
import { useGetDivision } from 'hooks'

type DivisionProps = {
  divisionState: { division: string[]; reportName?: string }
  onChange(division: string[], isDefaultAll?: boolean): void
  disabled?: boolean
}

export const SelectDivision = (props: DivisionProps) => {
  const { divisionState, onChange, disabled } = props
  const { division, reportName } = divisionState

  const { getDivisionStatus, getIsDivisionLoading, divisionData, getDivisionError } = useGetDivision({ reportName })

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (getDivisionStatus === 'error') {
      return getDivisionError?.errorMessage ?? 'Network Error!'
    }
    if (!division.length) {
      if (fieldError) return true
      else if (setValidation) setFieldError('triggered')
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const handleDivisionChange = (selectedDivision: string[], selectedDivisionText: string[], isDefaultAll?: boolean) => {
    onChange(selectedDivision, isDefaultAll)
  }

  return (
    <div className="w-full sm:w-64" data-testid={`select-division`}>
      <MultiSelect
        placeholder="Select division"
        label="Division *"
        id="division"
        isLoading={getIsDivisionLoading}
        disabled={disabled}
        value={division}
        onChange={handleDivisionChange}
        options={(divisionData || [])?.map((item) => ({
          value: item.commercial_division,
          text: item.commercial_division,
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
      />
    </div>
  )
}
